import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=02b679cf&scoped=true&"
import script from "./QuoteCard.vue?vue&type=script&lang=js&"
export * from "./QuoteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b679cf",
  null
  
)

export default component.exports